export var EMPTY_STRING = '';
export var DELIMITER = '|';
export var PREFIX = "UBI".concat(DELIMITER);
//# sourceMappingURL=constants.js.map